export const IR35_CLIENT_SETTINGS = [
  "freelancer_credits",
  "freelancer_equipment",
  "freelancer_introducing",
  "freelancer_managerial",
  "freelancer_staff",
];
